<template>
  <v-container fluid>
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ $t("pageHeader.tickets") }}</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          clearable
        >
        </v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        item-key="id"
        :items="tickets"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr class="pointer" @click="props.expanded = !props.expanded">
            <td class="text-xs-left">
              {{ $moment(props.item.createdAt).format("MM/DD/YYYY h:m a") }}
            </td>
            <td class="text-xs-left">{{ props.item.Store.CSPID }}</td>
            <td class="text-xs-left">{{ props.item.Store.businessName }}</td>
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.phoneNumber }}</td>
            <td class="text-xs-left">{{ props.item.title }}</td>
            <td class="text-xs-left">{{ props.item.priorityDetail.selector }}</td>
            <td
              class="text-xs-left"
              v-if="props.item.assignedToUser &amp;&amp; props.item.assignedToUser.fullName"
            >
              {{ props.item.assignedToUser.fullName }}
            </td>
            <td class="text-xs-left" v-else>n/a</td>
            <td class="text-xs-left">{{ $moment(props.item.dueDate).format("MM/DD h:m a") }}</td>
            <td class="text-xs-left">{{ props.item.statusDetail.selector }}</td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <v-card>
            <v-card class="elevation-15" dark color="#1B1B1D">
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <h3 class="font-weight-bold mb-3" style="color: #21C593;">Ticket</h3>
                    <div class="font-weight-bold">{{ $t("labels.title") }}</div>
                    <div>{{ props.item.title }}</div>
                    <div class="mt-1 font-weight-bold">{{ $t("labels.description") }}</div>
                    <div>{{ props.item.description }}</div>
                    <div class="mt-1 font-weight-bold" v-if="props.item.solution">
                      {{ $t("labels.solution") }}
                    </div>
                    <div>{{ props.item.solution }}</div>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <h3 class="font-weight-bold mb-3" style="color: #21C593;">Contact</h3>
                    <div class="mt-1 font-weight-bold">{{ $t("labels.name") }}</div>
                    <div>{{ props.item.name }}</div>
                    <div class="mt-1 font-weight-bold">{{ $t("labels.phoneNumber") }}</div>
                    <div>{{ props.item.phoneNumber }}</div>
                    <div class="mt-1 font-weight-bold">{{ $t("labels.emailAddress") }}</div>
                    <div>{{ props.item.email }}</div>
                    <div class="mt-1 font-weight-bold">{{ $t("labels.status") }}</div>
                    <div>{{ props.item.statusDetail.selector }}</div>
                  </v-flex>

                  <v-layout row wrap>
                    <v-btn color="info" @click="gotoPage(props.item)">Go to page</v-btn>
                    <v-btn color="info" flat @click="gotoPageNewTab(props.item)">
                      <v-icon left="left">open_in_new </v-icon>Open in new tab</v-btn
                    >
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card>
          </v-card>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import ticketService from "../service.js";
import { mapGetters } from "vuex";

export default {
  props: ["tickets", "loading", "title"],
  data() {
    return {
      headers: [
        {
          text: this.$t("labels.createdAt"),
          value: "createdAt",
          sortable: true
        },
        {
          text: this.$t("labels.cspid"),
          value: "Store.CSPID",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.storeName"),
          value: "Store.businessName",
          sortable: true
        },
        {
          text: this.$t("labels.name"),
          value: "name",
          sortable: true
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "phoneNumber",
          sortable: true
        },
        {
          text: this.$t("labels.title"),
          value: "ticketTypeDetail.selector",
          sortable: true
        },
        {
          text: this.$t("labels.priority"),
          value: "priorityDetail.selector",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.assignedTo"),
          value: "assignedToUser.fullName",
          sortable: true
        },
        {
          text: this.$t("labels.dueDate"),
          value: "dueDate",
          sortable: true
        },
        {
          text: this.$t("labels.status"),
          value: "statusDetail.selector",
          sortable: true
        }
      ],
      search: null,
      pagination: {
        rowsPerPage: 10,
        sortBy: "createdAt",
        descending: true
      }
    };
  },
  computed: {
    ...mapGetters("location", ["location"]),
    ...mapGetters("global", ["comboBox", "ComboBox", "comboBoxByID", "currentUser"])
  },
  methods: {
    gotoPageNewTab(data) {
      let routeData = this.$router.resolve({ path: `/tickets/profile/${data.id}` });
      window.open(routeData.href, "_blank");
    },
    gotoPage(data) {
      this.$router.push({ path: `/tickets/profile/${data.id}` });
    }
  }
};
</script>

<style scoped></style>
